import VueGtag, { event, pageview, screenview } from 'vue-gtag';


export default defineNuxtPlugin((nuxtApp) => {
  if (process.server) {
    return;
  }
  const getCookieSettings = localStorage.getItem('cookie:accepted');

  nuxtApp.vueApp.use(VueGtag, {
    config: { id: 'G-KT9B09E9BE' },
    bootstrap: getCookieSettings === 'true',
    appName: 'BNPL Client',
    enabled: getCookieSettings === 'true',
  });

  return {
    provide: {
      gtag: {
        event: event,
        pageview: pageview,
        screenview: screenview
      }
    }
  };
});